var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8917_6562)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4176 0 16 3.58243 16 8C16 12.4176 12.4176 16 8 16C3.58243 16 0 12.4176 0 8C0 3.58243 3.58243 0 8 0ZM3.95654 10.8957L6.85222 8L3.95654 5.10431C3.79043 4.93814 3.79043 4.66709 3.95654 4.50098L4.50098 3.95654C4.66709 3.79043 4.93814 3.79043 5.10431 3.95654L8 6.85222L10.8957 3.95654C11.0619 3.79043 11.3329 3.79043 11.499 3.95654L12.0435 4.50098C12.2096 4.66709 12.2096 4.93814 12.0435 5.10431L9.14778 8L12.0435 10.8957C12.2096 11.0619 12.2096 11.3329 12.0435 11.499L11.499 12.0435C11.3329 12.2096 11.0619 12.2096 10.8957 12.0435L8 9.14778L5.10431 12.0435C4.93814 12.2096 4.66709 12.2096 4.50098 12.0435L3.95654 11.499C3.79043 11.3329 3.79043 11.0619 3.95654 10.8957Z",
    fill: "#FF4141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8917_6562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcon);
export default __webpack_public_path__ + "static/media/rejected-icon.83d12aa580f95bced47daae2a33f1b0a.svg";
export { ForwardRef as ReactComponent };